/**
 *  //平台&菜单操作Menu Controller
 */

import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const menu = {
  //GET/menu/query查询当前登录用户所有菜单项
  getmenu() {
    return axios.get(`${base.baseURL}menu/query`)
  },
  //GET/menu/query/{roleId}查询所有菜单项(条件:角色roleId)
  menubyrolleid(roleId) {
    return axios.get(`${base.baseURL}menu/query/${roleId}`)
  },
  //GET/menu/queryall/{menuType}查询所有菜单项(条件:菜单类型menuType)
  // getmenuall(menuType) {
  //   return axios.get(`${base.baseURL}menu/queryall/${menuType}`)
  // },
  //GET/menu/queryIcon/{menuId}查询当前登录用户按钮项
  // menuqueryIcon(menuId) {
  //   return axios.get(`${base.baseURL}menu/queryIcon${menuId}`)
  // },
  // GET/menu/queryTenant 查询租户下所有菜单项------ygt
  //GET/menu/queryall/{menuType}查询所有菜单项(条件:菜单类型menuType)
  // getTentMenu() {
  //   return axios.get(`${base.baseURL}menu/queryTenant`)
  // },
  // GET /menu/listMenu/{type} pc api---查询菜单项
  getTentMenu(type,roleId) {
    return axios.get(`${base.baseURL}menu/listMenu/${type}?roleId=${roleId}`)
  },
}

export default menu;



// WEBPACK FOOTER //
// ./src/network/menu.js